module.exports = __webpack_public_path__ + "media/images/icon_list/point-2ddd8911f6e2f760c93e0f46f1f099ef.svg";